export class Settings {
     categoryEnglshName:String;
    categoryFrnchName:String;
    id:number;
   activeIndicator:String;
  
    

   }